import React from 'react'
import { Button } from 'react-bootstrap'
import { apvSurveyBanner } from '@revbox/localization'

const ApvSurveyBanner = ({ language }) => {
    return (
        <div className="alert alert-success d-flex justify-content-between align-items-center" role="alert">
            <div className="d-flex align-items-center">
                <i className="ri-alert-line me-2"></i>
                {apvSurveyBanner[language].content}
            </div>
            <div>
                <a href={apvSurveyBanner[language].link} target="_blank" rel="noopener noreferrer">
                    <Button variant="success">
                        {apvSurveyBanner[language].linkText} <i className="ri-external-link-line"></i>
                    </Button>
                </a>
            </div>
        </div>
    )
}

export default ApvSurveyBanner
